import React, { useEffect, useState } from 'react'
import { getGiftAmount } from '@service/api'
import { LayoutProvider } from '@components/Context'

const Boostrap = ({ children, pageContext }) => {
  const updateShowLayout = (flag) => {
    updateStore((store) => {
      return { ...store, showLayout: flag }
    })
  }

  const updateWidthAuto = (widthAuto) => {
    updateStore((store) => {
      return { ...store, widthAuto }
    })
  }

  const initialStoreState = {
    giftAmout: 688,
    showLayout: true,
    widthAuto: pageContext?.widthAuto ? true : false,
    updateShowLayout: updateShowLayout,
    updateWidthAuto: updateWidthAuto
  }

  const [store, updateStore] = useState(initialStoreState)

  useEffect(() => {
    getGiftAmount()
      .then(res => {
        updateStore(prevState => {
          return { ...prevState, giftAmout: res }
        })
      })
  }, [])

  return (
    <LayoutProvider value={store}>
      {children}
    </LayoutProvider>
  )
}

export default Boostrap
